<template>
    <div class="mrt20">
        <el-row>
            <el-col :span="4">
                <div>
                    <el-table
                            height="940"
                            :data="wtgsData"
                            style="width: 100%"

                            :header-cell-style="{background:'#eef1f6',color:'#000'}"
                    >
                        <el-table-column
                                prop="vc_name"
                                :label="$t('form_entrust_company')">
                        </el-table-column>
                    </el-table>
                </div>
            </el-col>
            <el-col :span="20">
                <template>
                    <el-tabs type="border-card" @tab-click="dataListClick" >
                        <el-tab-pane   label="生产计划" >
                            <div v-if="tabIndex == '0'">
                                <div class="mrl20">
                                    <el-button type="primary" class="mrt10" :class="baseerp+'btn'" @click="addData">添加</el-button>
                                    <el-table
                                            class="mrt20"
                                            :data="productionData"
                                            style="width: 100%"
                                            max-height="900"
                                            height="810"
                                            :header-cell-style="{background:'#eef1f6',color:'#000'}">
                                        <el-table-column
                                                prop="pid"
                                                label="计划编号"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_pmname"
                                                :label="$t('form_entrust_company')"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_no"
                                                label="代工厂"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_num"
                                                label="加工产品"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_num"
                                                label="计划数量"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_unit"
                                                :label="$t('form_metering')"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="dt_createtime"
                                                label="类型"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_lruname"
                                                label="录入时间"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_processCompany"
                                                label="定制任务量"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_entrustCompany"
                                                label="已产出量"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_ckName"
                                                label="已交付量"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                fixed="right"
                                                label="操作"
                                                width="50">
                                            <template slot-scope="scope">
                                                <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <!--分页-->
                                    <div>
                                        <el-pagination
                                                background
                                                style="color: #e8c984"
                                                class="fr page "
                                                layout="prev, pager, next"
                                                @current-change="pageCurrentChange"
                                                :current-page.sync="currentPage"
                                                :total="tableTotal"
                                                :page-size="pageSize">
                                        </el-pagination>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane  label="生产任务">
                            <div v-if="tabIndex == '1'">
                                <div class="mrl20">
                                    <!--头部-->
                                    <div class="choosedate  mrt20">
                                        <el-input  style="width: 15%" v-model="taskvcNo" placeholder="请输入编号" clearable></el-input>
                                        <el-button class="mrl20" icon="el-icon-search" circle @click="taskSearch"></el-button>
                                    </div>
                                    <el-table
                                            class="mrt20"
                                            :data="taskData"
                                            style="width: 100%"
                                            max-height="900"
                                            height="810"
                                            :header-cell-style="{background:'#eef1f6',color:'#000'}">
                                        <el-table-column
                                                prop="i_id"
                                                label="计划编号">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_pzname"
                                                :label="$t('promanagement_production_task_number')"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_no"
                                                label="代工厂"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_unit"
                                                label="产品">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_outnum"
                                                label="数量">
                                        </el-table-column>
                                        <el-table-column
                                                prop="kysl"
                                                label="已产出量">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_bc"
                                                label="已交付量">
                                        </el-table-column>
                                        <el-table-column
                                                fixed="right"
                                                label="操作"
                                                width="80">
                                            <template slot-scope="scope">
                                                <el-button @click="taskwatchClick(scope.row)" type="text" size="small">查看</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <!--分页-->
                                    <div>
                                        <el-pagination
                                                background
                                                style="color: #e8c984"
                                                class="fr page "
                                                layout="prev, pager, next"
                                                @current-change="taskPageCurrentChange"
                                                :current-page.sync="taskCurrentPage"
                                                :total="taskTableTotal"
                                                :page-size="taskPageSize">
                                        </el-pagination>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane  label="生产产出">
                            <div v-if="tabIndex == '2'">
                                <div class="mrl20">
                                    <!--头部-->
                                    <div class="choosedate mrl20 mrt20">
                                        <span class="mrt10">选择生产产出日期:</span>
                                        <el-date-picker
                                                v-model="examinebegin_time"
                                                format="yyyy-MM-dd"
                                                value-format="yyyy-MM-dd"
                                                type="date"
                                                placeholder="选择日期">
                                        </el-date-picker>
                                        <span class="mrt10">至</span>
                                        <el-date-picker
                                                v-model="examineend_time"
                                                format="yyyy-MM-dd"
                                                value-format="yyyy-MM-dd"
                                                type="date"
                                                placeholder="选择日期">
                                        </el-date-picker>
                                        <el-input class="mrl20" style="width: 15%" v-model="examinevcNo" placeholder="请输入生产批次号" clearable></el-input>
                                        <el-button class="mrl20" icon="el-icon-search" circle @click="examineSearch"></el-button>
                                    </div>
                                    <el-table
                                            class="mrt20"
                                            :data="examineData"
                                            style="width: 100%"
                                            max-height="900"
                                            height="810"
                                            :header-cell-style="{background:'#eef1f6',color:'#000'}">
                                        <el-table-column
                                                prop="i_outid"
                                                :label="$t('form_serial_number')"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_pzname"
                                                :label="$t('form_finished_goods')"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_no"
                                                label="生产批次号"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_unit"
                                                :label="$t('form_metering')">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_num"
                                                :label="$t('form_delivery_quantity')">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_state"
                                                label="状态">
                                        </el-table-column>
                                        <el-table-column
                                                prop="dt_jfcreatetime"
                                                label="审核时间"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_jfuname"
                                                label="交付人">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_jgmoney"
                                                label="加工费"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_note"
                                                :label="$t('form_notes')"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                fixed="right"
                                                label="操作"
                                                width="80">
                                            <template slot-scope="scope">
                                                <el-button @click="examineWatchClick(scope.row)" type="text" size="small">查看</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <!--分页-->
                                    <div>
                                        <el-pagination
                                                background
                                                style="color: #e8c984"
                                                class="fr page"
                                                layout="prev, pager, next"
                                                @current-change="examinePageCurrentChange"
                                                :current-page.sync="examineCurrentPage"
                                                :total="examineTableTotal"
                                                :page-size="examinePageSize">
                                        </el-pagination>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane  label="交付">
                            <div v-if="tabIndex == '3'">
                                <div class="mrl20">
                                    <!--头部-->
                                    <div class="choosedate mrl20 mrt20">
                                        <el-input   style="width: 15%" v-model="taskvcNo" placeholder="请输入批次号" clearable></el-input>
                                        <el-button class="mrl20" icon="el-icon-search" circle ></el-button>
                                        <el-button type="primary" class="mrt10 mrl20" :class="baseerp+'btn'">批量交付</el-button>
                                    </div>
                                    <el-table
                                            class="mrt20"
                                            :data="paymentData"
                                            style="width: 100%"
                                            max-height="900"
                                            height="810"
                                            :header-cell-style="{background:'#eef1f6',color:'#000'}">
                                        <el-table-column
                                                type="selection"
                                                width="55">
                                        </el-table-column>
                                        <el-table-column
                                                prop="i_outid"
                                                label="生产计划编号">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_pzname"
                                                :label="$t('promanagement_production_task_number')"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_no"
                                                :label="$t('form_finished_goods')"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_unit"
                                                :label="$t('form_batch_number')">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_num"
                                                label="数量">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_state"
                                                :label="$t('form_metering')">
                                        </el-table-column>
                                        <el-table-column
                                                prop="dt_jfcreatetime"
                                                label="班次"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_jfuname"
                                                label="生产线">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_note"
                                                :label="$t('form_notes')">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_jgmoney"
                                                label="录入时间">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_jgmoney"
                                                label="录入人">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_jgmoney"
                                                label="状态">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_jgmoney"
                                                label="交付时间">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_jgmoney"
                                                label="交付人">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_jgmoney"
                                                label="加工费">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_jgmoney"
                                                label="包装费">
                                        </el-table-column>
                                        <el-table-column
                                                fixed="right"
                                                label="操作"
                                                width="60">
                                            <template slot-scope="scope">
                                                <el-button type="text" size="small" v-if="scope.row.i_outid==1" >查看</el-button>
                                                <el-button type="text" size="small" v-else >交付</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <!--分页-->
                                    <div>
                                        <el-pagination
                                                background
                                                style="color: #e8c984"
                                                class="fr page "
                                                layout="prev, pager, next"
                                                :current-page.sync="paymentCurrentPage"
                                                :total="paymentTableTotal"
                                                :page-size="paymentPageSize">
                                        </el-pagination>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </template>
            </el-col>
        </el-row>
        <div>
            <!--生产计划dialog-->
            <div :class="baseerp+'div'">
                <el-dialog
                        width="1350px"
                        :title="title"
                        :visible.sync="dialogVisible"
                        :close-on-click-modal="false"
                        @close="cancelDialog"
                        v-if="dialogVisible">
                    <plan-form :planForm="planForm" @close="cancelDialog" ></plan-form>
                </el-dialog>
            </div>
            <!--生产任务dialog-->
            <div :class="baseerp+'div'">
                <el-dialog
                        width="1350px"
                        :title="tasktitle"
                        :visible.sync="taskdialogVisible"
                        :close-on-click-modal="false"
                        @close="cancelDialog"
                        v-if="taskdialogVisible">
                    <task-form :taskForm="taskForm" @close="cancelDialog" ></task-form>
                </el-dialog>
            </div>
            <!--生产产出dialog-->
            <div :class="baseerp+'div'">
                <el-dialog
                        width="1350px"
                        :title="examinetitle"
                        :visible.sync="examinedialogVisible"
                        :close-on-click-modal="false"
                        @close="cancelDialog"
                        v-if="examinedialogVisible">
                    <task-form :deliverForm="deliverForm" @close="cancelDialog" ></task-form>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
    // import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import PlanForm from "./components/PlanForm";
    import TaskForm from "./components/TaskForm";
    import RenderForm from "./components/RenderForm";
    import DeliverForm from "./components/DeliverForm";
    import {mapActions} from "vuex";
    export default {
        name: "putin",
        components: {TaskForm, PlanForm,RenderForm,DeliverForm},
        data() {
            return {

                baseerp:"",
                wtgsData:[],
                tabIndex:0,

                //生产计划
                productionData:[
                    {pid:1}
                ],
                pageSize:10,
                currentPage:1,
                tableTotal:0,
                planForm:{},
                dialogVisible:false,
                title:"",

                //生产任务
                taskData:[
                    {i_id:1}
                ],
                taskPageSize:10,
                taskCurrentPage:1,
                taskTableTotal:0,
                taskvcNo:"",
                tasktitle:"",
                taskdialogVisible:false,
                taskForm:{},

                //生产产出
                examineData:[
                    {i_outid:1}
                ],
                examineCurrentPage:1,
                examineTableTotal:0,
                examinePageSize:13,
                examinebegin_time:"",
                examineend_time:"",
                examinevcNo:"",
                examinetitle:"",
                examinedialogVisible:false,
                deliverForm:{},

                //产出交付
                paymentData:[
                    {i_outid:1},
                    {i_outid:2}
                ],
                paymentCurrentPage:1,
                paymentTableTotal:0,
                paymentPageSize:13,
            }
        },
        mounted() {
            this.baseerp=baseerp;
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            //查看生产产出当前行数据
            examineWatchClick(row){
                //console.log(roe,"查看审核当前行数据");
                this.examinetitle="查看生产产出";
                this.examinedialogVisible=true;
            },


            //生产产出查询
            examineSearch(){
                ///调用审核列表接口
                this.exagetProduceOutList();
            },

            //生产产出分页
            examinePageCurrentChange(val){
                this.examineCurrentPage=val;
                ///调用生产产出列表接口
            },

            //生产任务查询
            taskSearch(){
                ///调用生产任务列表接口

            },

            //点击生产任务分页
            taskPageCurrentChange(val){
                //console.log(val,"pageval");
                this.taskCurrentPage=val;
                ///调用生产计划列表接口

            },

            //查看生产任务
            taskwatchClick(row){
                //console.log(row,"查看生产任务");
                this.tasktitle="查看生产任务";
                this.taskdialogVisible=true;
            },

            //转生产任务带上特定条件
            handleClick(){},

            //点击生产计划分页
            pageCurrentChange(val){
                //console.log(val,"pageval");
                this.currentPage=val;
                ///调用生产计划列表接口

            },

            //点击生产计划新增
            addData(){
                this.dialogVisible=true;
                this.title="新增生产计划"
            },

            //选项框
            dataListClick(tab) {
                //console.log(tab,"tabtabtabtab");
                this.tabIndex = tab.index;
                if (this.id!==""&&this.tabIndex==0){
                    ///调用生产计划列表接口

                }else if (this.id!==""&&this.tabIndex==1){
                    ///调用生产任务列表接口

                }else if (this.id!==""&&this.tabIndex==2){
                    ///调用生产产出接口

                }else if (this.id!==""&&this.tabIndex==3){
                    ///调用交付列表接口



                }
            },

            //生产计划
            cancelDialog(){
                this.dialogVisible=false;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        justify-content: left;
    }
    .fl{
        float: left;
    }
    .fr{
        float: right;
    }
    .cl{
        clear: both;
    }
    .mrt10{
        margin-top: 10px;
    }
    .mrt20{
        margin-top: 20px;
    }
    .mrt70{
        margin-top: 70px;
    }
    .mrt80{
        margin-top: 80px;
    }
    .mrl20{
        margin-left: 10px;
    }

    /deep/{
        .content{
            display: none;
        }
        .el-dialog__body{
            word-break:unset;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
    }
</style>